<template>
  <div>
    <Modal v-model="show" :title="type == 'add' ? $t('add') : $t('edit')" :mask-closable="false" width="1200" @on-cancel="cancel">
      <div class="modal">
        <Form ref="form" :model="form" :rules="ruleInline" :label-width="155" label-colon>
          <Tabs :value="tabs" @on-click="ontabs" :animated="false">
            <Row :gutter="15" class="list">
              <TabPane :label="$t('Langue.zn')" name="1">
                <Col span="24" style="display: flex;">
                  <Col span="12">
                    <FormItem class="item_input" prop="zh-cn_title" :label="$t('title')">
                      <Input type="text" v-model="form['zh-cn_title']" placeholder="请输入标题"></Input>
                    </FormItem>
                    <FormItem class="item_input" prop="zh-cn_brief" :label="$t('brief')">
                      <Input type="text" v-model="form['zh-cn_brief']" placeholder="请输入简介"></Input>
                    </FormItem>
                    <FormItem class="item_input" prop="author" :label="$t('author')">
                      <Input type="text" v-model="form.author" placeholder="请输入作者"></Input>
                    </FormItem>
                    <FormItem class="item_input" prop="health_type" :label="$t('type')">
                      <Select v-model="form.health_type" placeholder="请选择">
                        <Option v-for="item in typeList" :value="item.key" :key="item.key">{{ item.value }}</Option>
                      </Select>
                    </FormItem>
                    <FormItem prop="sort_id" :label="$t('sort')">
                      <InputNumber :min="1" v-model="form.sort_id" :placeholder="tabs == 1 ? '请输入排序顺序' : tabs == 2 ? '請輸入排序順序' : 'Please enter the sort order'"></InputNumber>
                    </FormItem>
                    <FormItem class="item_input" prop="productId" :label="$t('product_ids')">
                      <Select v-model="form.productId" multiple placeholder="请选择">
                        <Scroll :on-reach-bottom="handleReachBottom2" height="200">
                          <Option v-for="item in productList" :value="item.id" :key="item.id">{{ item.title }}</Option>
                        </Scroll>
                      </Select>
                    </FormItem>
                    <FormItem class="item_input" prop="wellnessId" :label="$t('wellness_ids')">
                      <Select v-model="form.wellnessId" multiple placeholder="请选择">
                        <Scroll :on-reach-bottom="handleReachBottom" height="200">
                          <Option v-for="item in WellnessList" :value="item.wellness_id" :key="item.wellness_id">{{ item.title }}</Option>
                        </Scroll>
                      </Select>
                    </FormItem>
                  </Col>
                  <Col span="12">
                    <FormItem class="item_input" :label="'Facebook'">
                      <Input type="text" v-model="form.share_link1" :placeholder="$t('Ad.url_link_input')"></Input>
                    </FormItem>
                    <FormItem class="item_input" :label="'Instagram'">
                      <Input type="text" v-model="form.share_link2" :placeholder="$t('Ad.url_link_input')"></Input>
                    </FormItem>
                    <FormItem class="item_input" :label="'Whatsapp'">
                      <Input type="text" v-model="form.share_link3" :placeholder="$t('Ad.url_link_input')"></Input>
                    </FormItem>
                    <FormItem :label="$t('onTop')" prop="top">
                      <i-Switch size="large" v-model="form.top" true-value="1" false-value="0" />
                    </FormItem>
                    <FormItem :label="$t('isHome')" prop="is_home">
                      <i-Switch size="large" v-model="form.is_home" true-value="1" false-value="0" />
                    </FormItem>
                    <FormItem :label="$t('status')" prop="status">
                      <i-Switch size="large" v-model="form.status" true-value="A2" false-value="A1" />
                    </FormItem>
                  </Col>
                </Col>
                <Col span="24" style="display: flex;">
                  <Col span="12">
                    <FormItem :label="$t('img_lnk') + ' - PC'" prop="images">
                      <div class="demo-upload-list2" v-for="(item, index) in form.images" :key="index">
                        <template>
                          <img :src="item.file_lnk" />
                          <div class="demo-upload-list-cover">
                            <Icon class="icondel" type="md-close-circle" @click.native="handleRemove(index)"></Icon>
                          </div>
                        </template>
                      </div>
                      <Upload ref="upload" :show-upload-list="false" :before-upload="(value) => handleBeforeUpload(value, 4)" type="drag" action style="display: inline-block;width:78px;">
                        <div style="width: 76px;height:76px;line-height: 80px;">
                          <Icon type="ios-add-circle-outline" size="30" style="color:#6096FF" />
                        </div>
                      </Upload>
                      <div class="photo_tip">{{ $t('photo_tip') + " 1200 x 630" }}</div>
                      <div>
                        <Button type="primary" @click="onCopyImgPc(1)">{{ $t('Copy_language') }}</Button>
                      </div>
                    </FormItem>
                  </Col>
                  <Col span="12">
                    <FormItem :label="$t('img_lnk') + ' - Mobile'" prop="mobile_images">
                      <div class="demo-upload-list2" v-for="(item, index) in form.mobile_images" :key="index">
                        <template>
                          <img :src="item.file_lnk" />
                          <div class="demo-upload-list-cover">
                            <Icon class="icondel" type="md-close-circle" @click.native="handleRemove4(index)"></Icon>
                          </div>
                        </template>
                      </div>
                      <Upload ref="upload" :show-upload-list="false" :before-upload="(value) => handleBeforeUpload(value, 10)" type="drag" action style="display: inline-block;width:78px;">
                        <div style="width: 76px;height:76px;line-height: 80px;">
                          <Icon type="ios-add-circle-outline" size="30" style="color:#6096FF" />
                        </div>
                      </Upload>
                      <div class="photo_tip">{{ $t('photo_tip') + " 360*200" }}</div>
                      <div>
                        <Button type="primary" @click="onCopyImg(1)">{{ $t('Copy_language') }}</Button>
                      </div>
                    </FormItem>
                  </Col>
                </Col>
                <Col span="24">
                  <FormItem prop="zh-cn_content" :label="$t('content')">
                    <vue-editor
                      v-model="form['zh-cn_content']"
                      placeholder="请输入内容"
                      :editor-toolbar="customToolbar"
                      :editorOptions="editorSettings"
                      :customModules="customModulesForEditor"
                      @image-added="handleImageAdded"
                      :useCustomImageHandler="true"
                    />
                  </FormItem>
                </Col>
              </TabPane>
              <TabPane :label="$t('Langue.tw')" name="2">
                <Col span="24" style="display: flex;">
                  <Col span="12">
                    <FormItem class="item_input" prop="zh-tw_title" :label="$t('title')">
                      <Input type="text" v-model="form['zh-tw_title']" placeholder="請輸入標題"></Input>
                    </FormItem>
                    <FormItem class="item_input" prop="zh-tw_brief" :label="$t('brief')">
                      <Input type="text" v-model="form['zh-tw_brief']" placeholder="請輸入簡介"></Input>
                    </FormItem>
                    <FormItem class="item_input" prop="author" :label="$t('author')">
                      <Input type="text" v-model="form.author" placeholder="請輸入作者"></Input>
                    </FormItem>
                    <FormItem class="item_input" prop="health_type" :label="$t('type')">
                      <Select v-model="form.health_type" placeholder="請選擇">
                        <Option v-for="item in typeList" :value="item.key" :key="item.key">{{ item.value }}</Option>
                      </Select>
                    </FormItem>
                    <FormItem prop="sort_id" :label="$t('sort')">
                      <InputNumber :min="1" v-model="form.sort_id" :placeholder="tabs == 1 ? '请输入排序顺序' : tabs == 2 ? '請輸入排序順序' : 'Please enter the sort order'"></InputNumber>
                    </FormItem>
                    <FormItem class="item_input" prop="productId" :label="$t('product_ids')">
                      <Select v-model="form.productId" multiple placeholder="請選擇">
                        <Scroll :on-reach-bottom="handleReachBottom2" height="200">
                          <Option v-for="item in productList" :value="item.id" :key="item.id">{{ item.title }}</Option>
                        </Scroll>
                      </Select>
                    </FormItem>
                    <FormItem class="item_input" prop="wellnessId" :label="$t('wellness_ids')">
                      <Select v-model="form.wellnessId" multiple placeholder="請選擇">
                        <Scroll :on-reach-bottom="handleReachBottom" height="200">
                          <Option v-for="item in WellnessList" :value="item.wellness_id" :key="item.wellness_id">{{ item.title}}</Option>
                        </Scroll>
                      </Select>
                    </FormItem>
                  </Col>
                  <Col span="12">
                    <FormItem class="item_input" :label="'Facebook'">
                      <Input type="text" v-model="form.share_link1" :placeholder="$t('Ad.url_link_input')"></Input>
                    </FormItem>
                    <FormItem class="item_input" :label="'Instagram'">
                      <Input type="text" v-model="form.share_link2" :placeholder="$t('Ad.url_link_input')"></Input>
                    </FormItem>
                    <FormItem class="item_input" :label="'Whatsapp'">
                      <Input type="text" v-model="form.share_link3" :placeholder="$t('Ad.url_link_input')"></Input>
                    </FormItem>
                    <FormItem :label="$t('onTop')" prop="top">
                      <i-Switch size="large" v-model="form.top" true-value="1" false-value="0" />
                    </FormItem>
                    <FormItem :label="$t('isHome')" prop="is_home">
                      <i-Switch size="large" v-model="form.is_home" true-value="1" false-value="0" />
                    </FormItem>
                    <FormItem :label="$t('status')" prop="status">
                      <i-Switch size="large" v-model="form.status" true-value="A2" false-value="A1" />
                    </FormItem>
                  </Col>
                </Col>
                <Col span="24" style="display: flex;">
                  <Col span="12">
                    <FormItem :label="$t('img_lnk') + ' - PC'" prop="tw_images">
                      <div class="demo-upload-list2" v-for="(item, index) in form.tw_images" :key="index">
                        <template>
                          <img :src="item.file_lnk" />
                          <div class="demo-upload-list-cover">
                            <Icon class="icondel" type="md-close-circle" @click.native="handleRemove2(index)"></Icon>
                          </div>
                        </template>
                      </div>
                      <Upload ref="upload" :show-upload-list="false" :before-upload="(value) => handleBeforeUpload(value, 5)" type="drag" action style="display: inline-block;width:78px;">
                        <div style="width: 76px;height:76px;line-height: 80px;">
                          <Icon type="ios-add-circle-outline" size="30" style="color:#6096FF" />
                        </div>
                      </Upload>
                      <div class="photo_tip">{{ $t('photo_tip') + " 1200 x 630" }}</div>
                      <div>
                        <Button type="primary" @click="onCopyImgPc(2)">{{ $t('Copy_language') }}</Button>
                      </div>
                    </FormItem>
                  </Col>
                  <Col span="12">
                    <FormItem :label="$t('img_lnk') + ' - Mobile'" prop="tw_mobile_images">
                      <div class="demo-upload-list2" v-for="(item, index) in form.tw_mobile_images" :key="index">
                        <template>
                          <img :src="item.file_lnk" />
                          <div class="demo-upload-list-cover">
                            <Icon class="icondel" type="md-close-circle" @click.native="handleRemove5(index)"></Icon>
                          </div>
                        </template>
                      </div>
                      <Upload ref="upload" :show-upload-list="false" :before-upload="(value) => handleBeforeUpload(value, 11)" type="drag" action style="display: inline-block;width:78px;">
                        <div style="width: 76px;height:76px;line-height: 80px;">
                          <Icon type="ios-add-circle-outline" size="30" style="color:#6096FF" />
                        </div>
                      </Upload>
                      <div class="photo_tip">{{ $t('photo_tip') + " 360*200" }}</div>
                      <div>
                        <Button type="primary" @click="onCopyImg(2)">{{ $t('Copy_language') }}</Button>
                      </div>
                    </FormItem>
                  </Col>
                </Col>
                <Col span="24">
                  <FormItem prop="zh-tw_content" :label="$t('content')">
                    <vue-editor
                      v-model="form['zh-tw_content']"
                      placeholder="請輸入內容"
                      :editor-toolbar="customToolbar"
                      :editorOptions="editorSettings"
                      :customModules="customModulesForEditor"
                      @image-added="handleImageAdded"
                      :useCustomImageHandler="true"
                    />
                  </FormItem>
                </Col>
              </TabPane>
              <TabPane :label="$t('Langue.en')" name="3">
                <Col span="24" style="display: flex;">
                  <Col span="12">
                    <FormItem class="item_input" prop="en_title" :label="$t('title')">
                      <Input type="text" v-model="form.en_title" placeholder="Please enter title"></Input>
                    </FormItem>
                    <FormItem class="item_input" prop="en_brief" :label="$t('brief')">
                      <Input type="text" v-model="form.en_brief" placeholder="Please enter introduction"></Input>
                    </FormItem>
                    <FormItem class="item_input" prop="author" :label="$t('author')">
                      <Input type="text" v-model="form.author" placeholder="Please enter author"></Input>
                    </FormItem>
                    <FormItem class="item_input" prop="health_type" :label="$t('type')">
                      <Select v-model="form.health_type" placeholder="Please Select">
                        <Option v-for="item in typeList" :value="item.key" :key="item.key">{{ item.value }}</Option>
                      </Select>
                    </FormItem>
                    <FormItem prop="sort_id" :label="$t('sort')">
                      <InputNumber :min="1" v-model="form.sort_id" :placeholder="tabs == 1 ? '请输入排序顺序' : tabs == 2 ? '請輸入排序順序' : 'Please enter the sort order'"></InputNumber>
                    </FormItem>
                    <FormItem class="item_input" prop="productId" :label="$t('product_ids')">
                      <Select v-model="form.productId" multiple placeholder="Please Select">
                        <Scroll :on-reach-bottom="handleReachBottom2" height="200">
                          <Option v-for="item in productList" :value="item.id" :key="item.id">{{ item.title }}</Option>
                        </Scroll>
                      </Select>
                    </FormItem>
                    <FormItem class="item_input" prop="wellnessId" :label="$t('wellness_ids')">
                      <Select v-model="form.wellnessId" multiple placeholder="Please Select">
                        <Scroll :on-reach-bottom="handleReachBottom" height="200">
                          <Option v-for="item in WellnessList" :value="item.wellness_id" :key="item.wellness_id">{{ item.title }}</Option>
                        </Scroll>
                      </Select>
                    </FormItem>
                  </Col>
                  <Col span="12">
                    <FormItem class="item_input" :label="'Facebook'">
                      <Input type="text" v-model="form.share_link1" :placeholder="$t('Ad.url_link_input')"></Input>
                    </FormItem>
                    <FormItem class="item_input" :label="'Instagram'">
                      <Input type="text" v-model="form.share_link2" :placeholder="$t('Ad.url_link_input')"></Input>
                    </FormItem>
                    <FormItem class="item_input" :label="'Whatsapp'">
                      <Input type="text" v-model="form.share_link3" :placeholder="$t('Ad.url_link_input')"></Input>
                    </FormItem>
                    <FormItem :label="$t('onTop')" prop="top">
                      <i-Switch size="large" v-model="form.top" true-value="1" false-value="0" />
                    </FormItem>
                    <FormItem :label="$t('isHome')" prop="is_home">
                      <i-Switch size="large" v-model="form.is_home" true-value="1" false-value="0" />
                    </FormItem>
                    <FormItem :label="$t('status')" prop="status">
                      <i-Switch size="large" v-model="form.status" true-value="A2" false-value="A1" />
                    </FormItem>
                  </Col>
                </Col>
                <Col span="24" style="display: flex;">
                  <Col span="12">
                    <FormItem :label="$t('img_lnk') + ' - PC'" prop="en_images">
                      <div class="demo-upload-list2" v-for="(item, index) in form.en_images" :key="index">
                        <template>
                          <img :src="item.file_lnk" />
                          <div class="demo-upload-list-cover">
                            <Icon class="icondel" type="md-close-circle" @click.native="handleRemove3(index)"></Icon>
                          </div>
                        </template>
                      </div>
                      <Upload ref="upload" :show-upload-list="false" :before-upload="(value) => handleBeforeUpload(value, 6)" type="drag" action style="display: inline-block;width:78px;">
                        <div style="width: 76px;height:76px;line-height: 80px;">
                          <Icon type="ios-add-circle-outline" size="30" style="color:#6096FF" />
                        </div>
                      </Upload>
                      <div class="photo_tip">{{ $t('photo_tip') + " 1200 x 630" }}</div>
                      <div>
                        <Button type="primary" @click="onCopyImgPc(3)">{{ $t('Copy_language') }}</Button>
                      </div>
                    </FormItem>
                  </Col>
                  <Col span="12">
                    <FormItem :label="$t('img_lnk') + ' - Mobile'" prop="en_mobile_images">
                      <div class="demo-upload-list2" v-for="(item, index) in form.en_mobile_images" :key="index">
                        <template>
                          <img :src="item.file_lnk" />
                          <div class="demo-upload-list-cover">
                            <Icon class="icondel" type="md-close-circle" @click.native="handleRemove6(index)"></Icon>
                          </div>
                        </template>
                      </div>
                      <Upload ref="upload" :show-upload-list="false" :before-upload="(value) => handleBeforeUpload(value, 12)" type="drag" action style="display: inline-block;width:78px;">
                        <div style="width: 76px;height:76px;line-height: 80px;">
                          <Icon type="ios-add-circle-outline" size="30" style="color:#6096FF" />
                        </div>
                      </Upload>
                      <div class="photo_tip">{{ $t('photo_tip') + " 360*200" }}</div>
                      <div>
                        <Button type="primary" @click="onCopyImg(3)">{{ $t('Copy_language') }}</Button>
                      </div>
                    </FormItem>
                  </Col>
                </Col>
                <Col span="24">
                  <FormItem prop="en_content" :label="$t('content')">
                    <vue-editor
                      v-model="form.en_content"
                      placeholder="Please enter the content"
                      :editor-toolbar="customToolbar"
                      :editorOptions="editorSettings"
                      :customModules="customModulesForEditor"
                      @image-added="handleImageAdded"
                      :useCustomImageHandler="true"
                    />
                  </FormItem>
                </Col>
              </TabPane>
            </Row>
          </Tabs>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="cancel()">{{ $t("cancel") }}</Button>
        <Button type="primary" @click="submit('form')">{{ $t("sure") }}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { VueEditor, Quill } from 'vue2-editor'
// 导入图片操作相关插件
import { ImageDrop } from "quill-image-drop-module";
import ImageResize from "quill-image-resize-module";
Quill.register("modules/imageDrop", ImageDrop);
Quill.register("modules/imageResize", ImageResize);
export default {
  components: {
    VueEditor
  },
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    typeList: {
      type: Array,
      default: () => []
    },
    itemObj: Object,
    type: String
  },
  data () {
    const validateImg = (rule, value, callback) => {
      if (value == '') {
        callback(new Error(this.$t('p_upload_img')));
      } else {
        callback();
      }
    };
    return {
      tabs: '1',
      form: {
        wellness_id: "",
        en_title: "",
        en_brief: "",
        en_content: "",
        en_head_image: "",
        en_mobile_head_image: "",
        images: [],
        en_images: [],
        tw_images: [],
        mobile_images: [],
        tw_mobile_images: [],
        en_mobile_images: [],
        "zh-cn_title": "",
        "zh-cn_brief": "",
        "zh-cn_content": "",
        "zh-cn_head_image": "",
        "zh-cn_mobile_head_image": "",
        "zh-tw_title": "",
        "zh-tw_brief": "",
        "zh-tw_content": "",
        "zh-tw_head_image": "",
        "zh-tw_mobile_head_image": "",
        video: "",
        status: "A1",
        is_home: "0",
        top: "0",
        product_ids: "",
        wellness_ids: "",
        productId: [],
        wellnessId: [],
        sort_id: 1,
        author: '',
        health_type: '1',
        share_link1: "",
        share_link2: "",
        share_link3: "",
        share_link4: "",
        share_link5: "",
      },
      models: [],
      ruleInline: {
        author: [
          {
            required: true,
            message: this.$t("author_input"),
            trigger: "blur"
          }
        ],
        'zh-cn_title': [
          {
            required: true,
            message: this.$t("title_input"),
            trigger: "blur"
          }
        ],
        'zh-tw_title': [
          {
            required: true,
            message: this.$t("title_input"),
            trigger: "blur"
          }
        ],
        en_title: [
          {
            required: true,
            message: this.$t("title_input"),
            trigger: "blur"
          }
        ],
        'zh-cn_brief': [
          {
            required: true,
            message: this.$t("brief_input"),
            trigger: "blur"
          }
        ],
        'zh-tw_brief': [
          {
            required: true,
            message: this.$t("brief_input"),
            trigger: "blur"
          }
        ],
        en_brief: [
          {
            required: true,
            message: this.$t("brief_input"),
            trigger: "blur"
          }
        ],
        'zh-cn_content': [
          {
            required: true,
            message: this.$t("content_input"),
            trigger: "blur"
          }
        ],
        'zh-tw_content': [
          {
            required: true,
            message: this.$t("content_input"),
            trigger: "blur"
          }
        ],
        en_content: [
          {
            required: true,
            message: this.$t("content_input"),
            trigger: "blur"
          }
        ],
        health_type: [
          {
            required: true,
            message: this.$t("type_input"),
            trigger: "change"
          }
        ],
        productId: [
          { type: 'array', min: 1, message: this.$t("product_ids_input"), trigger: 'change' },
        ],
        wellnessId: [
          { type: 'array', min: 1, message: this.$t("wellness_ids_input"), trigger: 'change' },
        ],
        "zh-cn_head_image": [
          {
            required: true,
            trigger: 'change',
            validator: validateImg
          }
        ],
        "zh-tw_head_image": [
          {
            required: true,
            trigger: 'change',
            validator: validateImg
          }
        ],
        en_head_image: [
          {
            required: true,
            trigger: 'change',
            validator: validateImg
          }
        ],
        "zh-cn_mobile_head_image": [
          {
            required: true,
            trigger: 'change',
            validator: validateImg
          }
        ],
        "zh-tw_mobile_head_image": [
          {
            required: true,
            trigger: 'change',
            validator: validateImg
          }
        ],
        en_mobile_head_image: [
          {
            required: true,
            trigger: 'change',
            validator: validateImg
          }
        ],
        images: [
          {
            required: true,
            trigger: 'change',
            validator: validateImg
          }
        ],
        tw_images: [
          {
            required: true,
            trigger: 'change',
            validator: validateImg
          }
        ],
        en_images: [
          {
            required: true,
            trigger: 'change',
            validator: validateImg
          }
        ],
        mobile_images: [
          {
            required: true,
            trigger: 'change',
            validator: validateImg
          }
        ],
        tw_mobile_images: [
          {
            required: true,
            trigger: 'change',
            validator: validateImg
          }
        ],
        en_mobile_images: [
          {
            required: true,
            trigger: 'change',
            validator: validateImg
          }
        ],
        status: [
          {
            required: true,
            message: ' ',
            trigger: "blur"
          }
        ],
        is_home: [
          {
            required: true,
            message: ' ',
            trigger: "blur"
          }
        ],
        top: [
          {
            required: true,
            message: ' ',
            trigger: "blur"
          }
        ],
        sort_id: [
          {
            type: 'number',
            required: true,
            message: this.$t('sort_input'),
            trigger: 'blur'
          }
        ],
      },
      customToolbar: [
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ 'size': ['small', false, 'large', 'huge'] }],
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        [{ 'align': ['', 'center', 'right', 'justify'] }],
        ['blockquote'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'list': 'check' }],
        [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
        [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
        [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
        ['link', 'clean'],
        ["image", "video"]                             // remove formatting button
      ],
      // 设置编辑器图片可拖拽
      editorSettings: {
        modules: { imageDrop: true, imageResize: {} }
      },
      customModulesForEditor: [
        { alias: "imageDrop", module: ImageDrop },
        { alias: "imageResize", module: ImageResize }
      ],
      show: this.modal,
      page: {
        limit: 20,
        page: 1,
        wellness_ids: ""
      },
      page2: {
        limit: 20,
        page: 1,
        product_ids: ""
      },
      WellnessList: [],
      productList: [],
      total: 1,
      total2: 1,
    }

  },
  created () {
    this.info()

  },
  mounted () {

  },
  methods: {
    async info () {
      this.$base.showLoading();
      this.form.ad_id = this.$base.getRequest().id
      if (this.type != 'add') {
        this.$base.showLoading();
        this.$request.sendPost(
          'wellness/before-upd',
          { wellness_id: this.itemObj.wellness_id },
          (success, data, error) => {
            if (!success) return this.$base.alertErr(error.errmsg);
            this.form = data.info
            this.form.sort_id = data.info.sort_id * 1
            this.page2.product_ids = this.form.product_ids
            this.page.wellness_ids = this.form.wellness_ids
            let arr = [], arr2 = []
            arr = data.info.product_ids.split(',')
            arr2 = data.info.wellness_ids.split(',')
            arr.map(Number);
            arr2.map(Number);
            this.getDate(arr, arr2);
          }
        );
      } else {
        await this.getDate([], [])
      }
    },
    async getDate (arr, arr2) {
      this.$base.showLoading();
      await this.getWellnessList().then((e) => {
        this.total = e.last_page
        this.WellnessList = [...this.WellnessList, ...e.list]
        if (arr2.length > 0) {
          this.form.wellnessId = arr2
        }
      })
      await this.getProductList().then((e) => {
        this.total2 = e.last_page
        this.productList = [...this.productList, ...e.list]
        if (arr.length > 0) {
          this.form.productId = arr
        }
      })
      this.$base.hideLoading();
    },
    getWellnessList () {
      return new Promise(resolve => {
        this.$request.sendPost(
          'wellness/list', this.page,
          (success, data, error) => {
            if (!success) resolve(this.$base.msgErr(error.errmsg));
            resolve(data);
          }
        );

      });
    },
    getProductList () {
      return new Promise(resolve => {
        this.$request.sendPost(
          'com/get-product-data', this.page2,
          (success, data, error) => {
            if (!success) resolve(this.$base.msgErr(error.errmsg));
            resolve(data);
          }
        );

      });
    },
    onCopyImgPc (num) {
      switch (num) {
        case 1:
          if (this.form.images.length == 0) {
            this.$Message.error(this.$t('p_upload_img'));
            break;
          }
          this.form.tw_images = [...this.form.images]
          this.form.en_images = [...this.form.images]
          break;
        case 2:
          if (this.form.tw_images.length == 0) {
            this.$Message.error(this.$t('p_upload_img'));
            break;
          }
          this.form.images = [...this.form.tw_images]
          this.form.en_images = [...this.form.tw_images]
          break;
        case 3:
          if (this.form.en_images.length == 0) {
            this.$Message.error(this.$t('p_upload_img'));
            break;
          }
          this.form.tw_images = [...this.form.en_images]
          this.form.images = [...this.form.en_images]
          break;
      }
    },
    onCopyImg (num) {
      switch (num) {
        case 1:
          if (this.form.mobile_images.length == 0) {
            this.$Message.error(this.$t('p_upload_img'));
            break;
          }
          this.form.tw_mobile_images = [...this.form.mobile_images]
          this.form.en_mobile_images = [...this.form.mobile_images]
          break;
        case 2:
          if (this.form.tw_mobile_images.length == 0) {
            this.$Message.error(this.$t('p_upload_img'));
            break;
          }
          this.form.mobile_images = [...this.form.tw_mobile_images]
          this.form.en_mobile_images = [...this.form.tw_mobile_images]
          break;
        case 3:
          if (this.form.en_mobile_images.length == 0) {
            this.$Message.error(this.$t('p_upload_img'));
            break;
          }
          this.form.tw_mobile_images = [...this.form.en_mobile_images]
          this.form.mobile_images = [...this.form.en_mobile_images]
          break;
      }

    },
    handleReachBottom2 () {
      return new Promise(resolve => {
        this.page2.page++
        if (this.page2.page > this.total2) resolve(this.$base.msgErr(this.$t('noMore')));
        this.getProductList().then((e) => {
          this.total2 = e.last_page
          this.productList = [...this.productList, ...e.list]
          resolve();
        })
      });
    },
    handleReachBottom () {
      return new Promise(resolve => {
        this.page.page++
        if (this.page.page > this.total) resolve(this.$base.msgErr(this.$t('noMore')));
        this.getWellnessList().then((e) => {
          this.total = e.last_page
          this.WellnessList = [...this.WellnessList, ...e.list]
          resolve();
        })
      });
    },
    cancel () {
      this.$emit('cancel');
    },
    handleRemove (index) {
      this.form.images.splice(index, 1);
    },
    handleRemove2 (index) {
      this.form.tw_images.splice(index, 1);
    },
    handleRemove3 (index) {
      this.form.en_images.splice(index, 1);
    },
    handleRemove4 (index) {
      this.form.mobile_images.splice(index, 1);
    },
    handleRemove5 (index) {
      this.form.tw_mobile_images.splice(index, 1);
    },
    handleRemove6 (index) {
      this.form.en_mobile_images.splice(index, 1); 0
    },
    error () {
      this.$Message.error(this.$t("improve_information"));
    },
    ontabs (item) {
      this.tabs = item
    },
    // 自定义图片上传
    handleImageAdded (file, Editor, cursorLocation, resetUploader) {
      this.$base.showLoading();
      this.$base.uploadPicimg(file, file.name).then(res => {
        this.$base.hideLoading();
        if (res.url) {
          Editor.insertEmbed(cursorLocation, "image", res.url);
          resetUploader();
        }
      });

    },
    handleBeforeUpload (file, num) {
      this.$base.showLoading();
      this.$base.uploadPicimg(file, '').then(res => {
        this.$base.hideLoading();
        if (res.url) {
          let obj = {}
          switch (num) {
            case 1:
              this.form['zh-cn_head_image'] = res.url
              break;
            case 2:
              this.form['zh-tw_head_image'] = res.url
              break;
            case 3:
              this.form.en_head_image = res.url
              break;
            case 4:
              obj = {
                sort_id: this.form.images.length + 1,
                file_lnk: res.url
              }
              this.form.images.push(obj);
              break;
            case 5:
              obj = {
                sort_id: this.form.tw_images.length + 1,
                file_lnk: res.url
              }
              this.form.tw_images.push(obj);
              break;
            case 6:
              obj = {
                sort_id: this.form.en_images.length + 1,
                file_lnk: res.url
              }
              this.form.en_images.push(obj);
              break;
            case 7:
              this.form['zh-cn_mobile_head_image'] = res.url
              break;
            case 8:
              this.form['zh-tw_mobile_head_image'] = res.url
              break;
            case 9:
              this.form.en_mobile_head_image = res.url
              break;
            case 10:
              obj = {
                sort_id: this.form.mobile_images.length + 1,
                file_lnk: res.url
              }
              this.form.mobile_images.push(obj);
              break;
            case 11:
              obj = {
                sort_id: this.form.tw_mobile_images.length + 1,
                file_lnk: res.url
              }
              this.form.tw_mobile_images.push(obj);
              break;
            case 12:
              obj = {
                sort_id: this.form.en_mobile_images.length + 1,
                file_lnk: res.url
              }
              this.form.en_mobile_images.push(obj);
              break;
          }
        }
      });
    },
    submit (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.form.product_ids = this.form.productId.join(',')
          this.form.wellness_ids = this.form.wellnessId.join(',')
          this.$base.showLoading();
          this.$request.sendPost(
            this.type == 'add' ? 'wellness/add' : 'wellness/upd',
            this.form,
            (success, data, error) => {
              this.$base.hideLoading();
              if (!success) return this.$base.alertErr(error.errmsg);
              this.cancel()
              this.$emit('onOk');
            }
          );
        } else {
          this.error()
        }
      });
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .modal {
  .list {
    width: 100%;
    padding: 30px;
  }

  .ivu-tabs-nav-scroll {
    display: flex;
    justify-content: center;
  }

  .ivu-select-dropdown {
    overflow: hidden;
  }

  .demo-upload-list2 {
    width: 76px;
    height: 76px;
    position: relative;
    float: left;
    margin-right: 10px;
    margin-bottom: 10px;
    cursor: pointer;

    img {
      width: 76px;
      height: 76px;
      object-fit: cover;
      position: relative;
      // float: left;
      // border-radius: 50%;
    }

    .removeIcon {
      position: absolute;
      right: -7px;
      top: -7px;
      color: red;
      font-size: 16px;
      z-index: 8;
    }

    .eyeIcon {
      position: absolute;
      left: 50%;
      top: 50%;
      font-size: 30px;
      transform: translate(-50%, -50%);
      z-index: 7;
      font-weight: 550;
      display: none;
    }
  }

  .demo-upload-list2:hover {
    .eyeIcon {
      display: block;
    }
  }

  .demo-upload-list2 img {
    width: 100%;
    height: 100%;
    border: 1px solid #dcdee2;
  }

  .demo-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
  }

  .demo-upload-list2:hover .demo-upload-list-cover {
    display: block;
  }

  .demo-upload-list-cover .iconeye {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }

  .demo-upload-list-cover .icondel {
    position: absolute;
    top: -2px;
    right: -3px;
    color: #ff6262;
    font-size: 20px;
    cursor: pointer;
  }

  .demo-upload-list {
    display: inline-block;
    width: 300px;
    height: 150px;
    text-align: center;
    line-height: 100px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    margin-right: 4px;
  }

  .demo-upload-list img {
    width: 100%;
    height: 100%;
    border: 1px solid #dcdee2;
  }

  // .ivu-upload-drag {
  //   height: 150px;
  // }
  .ivu-btn-small {
    height: 24px;
    padding: 0 7px;
    font-size: 14px;
    border-radius: 3px;
  }

  .ivu-tabs {
    overflow: inherit;
  }

  .ivu-tabs-nav-scroll {
    display: flex;
    justify-content: center;
  }

  .ql-editor {
    height: 500px;
  }

  .photo_tip {
    color: #c5c8ce;
    font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/edu/wellness/module/wellness_edit.vue